import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import AuthReducer from './authenticationReducer';
import GeneralReducer from './generalReducer';
import DetailReducer from './detailsReducer';
import HomeReducer from './homeReducer';
import GlossaryReducer from './glossaryReducer';
import WhatsNewReducer from './whatsNewReducer';
import NewJoinerReducer from './newJoinerReducer';
import SearchResultsReducer from './searchResultsReducer';
import RefinerReducer from './refinerReducer';
import RecentlyViewedReducer from './recentlyViewedReducer';
import ContactReducer from './contactReducer';
import IsHomeComponentReducer from './checkHomeReducer';
import ClientDataReducer from './clientDataReducer';

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    authenticationData: AuthReducer,
    generalData: GeneralReducer,
    detailData: DetailReducer,
    homeData: HomeReducer,
    glossaryData: GlossaryReducer,
    whatsNewData: WhatsNewReducer,
    newJoinerData: NewJoinerReducer,
    searchResultData: SearchResultsReducer,
    refinerData: RefinerReducer,
    recentlyViewedData: RecentlyViewedReducer,
    contactData: ContactReducer,
    isHomeComponentReducer: IsHomeComponentReducer,
    clientDataReducer: ClientDataReducer,
  });
export default createRootReducer;
